import { get } from 'lodash';
import { itemGridColumn, itemGridSpacer, } from '../../sections/section-item-grid/css-classes';
export function getItemGridSmallScreenCss({ css }) {
    return getItemGridColumnPaddingsForSmallScreenCss({ css });
}
export function getItemGridColumnPaddingsForSmallScreenCss({ css }) {
    const spacerHeight = Math.min(parseInt(get(css, 'so-global-region-mix-separator.marginBottom') || '20px', 10), 20);
    return `
  .${itemGridColumn} > table > tbody > tr > td {
    padding: 0!important;
  }

  .${itemGridColumn} {
    padding-bottom: ${spacerHeight}px!important;
    padding-top: ${spacerHeight}px!important;
  }

  .${itemGridSpacer} div {
    height: ${spacerHeight}px!important;
  }
  `;
}
//# sourceMappingURL=get-item-grid-section-style.js.map